import { createAction } from 'redux-actions';

const NAMESPACE = 'CAR_CREATION_WIZARD';
export const SET_STEPS = NAMESPACE + '_SET_STEPS';
export const SET_ATTR_GROUPS = NAMESPACE + '_SET_ATTR_GROUPS';
export const GO_TO_STEP = NAMESPACE + '_GO_TO_STEP';
export const RESET_TARGET_STEP = NAMESPACE + '_RESET_TARGET_STEP';
export const SET_FORM_ERRORS = NAMESPACE + '_SET_FORM_ERRORS';
export const SET_ATTR_ERRORS = NAMESPACE + '_SET_ATTR_ERRORS';
export const LOAD_ATTR_GROUPS = NAMESPACE + '_LOAD_ATTR_GROUPS';
export const RESET = NAMESPACE + '_RESET';

export default {
  setSteps: createAction(SET_STEPS),
  loadAttributeGroups: createAction(LOAD_ATTR_GROUPS),
  setAttributeGroups: createAction(SET_ATTR_GROUPS),
  goToStep: createAction(GO_TO_STEP),
  resetTargetStep: createAction(RESET_TARGET_STEP),
  setFormErrors: createAction(SET_FORM_ERRORS),
  setAttrErrors: createAction(SET_ATTR_ERRORS),
  resetWizard: createAction(RESET),
};
